import React from "react";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const items = ["Frontend Developer", "Backend Developer", "UI/UX Designer", "React Native Developer", "Cloud Engineer", "Sales Executive"];

export default function Careers() {
  return (
    <section className="w-full lg:w-[80%] mx-auto px-4 sm:px-6 py-16">
      <div className="text-center max-w-4xl mx-auto mb-12">
        <div className="inline-flex px-4 py-2 rounded-full bg-white/10 border border-white/10 text-pink-100 mb-5">OjMee Technology</div>
        <h1 className="text-4xl sm:text-6xl font-black">Careers</h1>
        <p className="text-slate-300 mt-5 text-lg">Join OjMee Technology and work on modern AI, web, mobile and enterprise software projects.</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map((item) => (
          <div key={item} className="rounded-3xl bg-white/[0.07] border border-white/10 p-6 hover:border-pink-400/50 transition">
            <CheckCircle2 className="w-10 h-10 text-pink-300 mb-5" />
            <h3 className="text-2xl font-black">{item}</h3>
            <p className="text-slate-300 mt-3">Modern, secure and scalable solution designed for corporate business growth.</p>
          </div>
        ))}
      </div>

      <div className="mt-12 rounded-[2rem] bg-gradient-to-br from-pink-500/15 to-violet-800/20 border border-white/10 p-8 flex flex-col md:flex-row gap-6 md:items-center md:justify-between">
        <div>
          <h2 className="text-3xl font-black">Need a custom solution?</h2>
          <p className="text-slate-300 mt-2">OjMee can build it according to your business workflow.</p>
        </div>
        <Link to="/contact" className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-gradient-to-r from-pink-500 to-violet-700 font-bold">
          Contact Us <ArrowRight className="w-5 h-5" />
        </Link>
      </div>
    </section>
  );
}
